import { PartnerUserInterface } from "./definitions/partner-user-interface";
import { Injectable } from "@angular/core";
import { Apollo, QueryRef } from "apollo-angular";
import { ErrorsInterface } from "../errors/errors-interface";

interface PartnerUserByMeResponse {
  partnerUser: {
    byMe: {
      output: PartnerUserInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class PartnerUserByMeService {
  constructor(private apollo: Apollo) {}

  public getByMe(query: any): QueryRef<PartnerUserByMeResponse> {
    return this.apollo.watchQuery<PartnerUserByMeResponse>({
      query: query,
      fetchPolicy: "network-only",
    });
  }
}
